
import store from "./storage";

const OUTDATED_CODE = "OUTDATED_CODE";

export default {
  getOutdated() {
    return store.get(OUTDATED_CODE, "false") === "true";
  },
  setOutdated() {
    store.set(OUTDATED_CODE, "true");
  },
  setUpToDate() {
    store.set(OUTDATED_CODE, "false");
  }
};
